import { VagaroIcon } from "vagaro-website-rendering/src/components/Icons/SocialIcons";
import { AttributeFieldProps } from "./RenderAttributeInput";

export default function LinkToEditInVagaro({
  definition,
}: AttributeFieldProps) {
  return (
    <div className="wb-input-group">
      <div className="wb-input-row gray-hover">
        <a target="_blank" rel="noreferrer" href={definition.attKey}>
          Edit in Vagaro &nbsp;
          <VagaroIcon />
        </a>
      </div>
    </div>
  );
}

export function LinkToEditInVagaroFromLink({ link }: { link: string }) {

  let newLink = link;
  if(!window.location.hostname.includes('mysite.vagaro.com')){
   newLink = link.replace('www.vagaro.com','dev24.bookitall.com');
  }

  return (
    <div className="wb-input-group">
      <div className="wb-input-row gray-hover">
        <a target="_blank" rel="noreferrer" href={newLink}>
          Edit in Vagaro &nbsp;
          <VagaroIcon />
        </a>
      </div>
    </div>
  );
}
